import { memo } from "react"

const SkeletonComponent = () => (
    <h1>loading ...</h1>
)

export default memo(SkeletonComponent);